import { render, staticRenderFns } from "./editBranches.vue?vue&type=template&id=235e337f&scoped=true"
import script from "./editBranches.vue?vue&type=script&lang=js"
export * from "./editBranches.vue?vue&type=script&lang=js"
import style0 from "./editBranches.vue?vue&type=style&index=0&id=235e337f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e337f",
  null
  
)

export default component.exports